var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAttachment = function SvgAttachment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.06 4.947 5.784 8.44a1.18 1.18 0 0 0-.313.806c0 .303.113.593.313.807.2.213.473.333.756.333.284 0 .556-.12.756-.333l3.276-3.494a2.36 2.36 0 0 0 .626-1.612 2.36 2.36 0 0 0-.627-1.612 2.072 2.072 0 0 0-1.511-.668c-.567 0-1.111.24-1.512.668L4.273 6.828a3.54 3.54 0 0 0-.94 2.418c0 .907.338 1.777.94 2.419a3.109 3.109 0 0 0 2.267 1.002c.85 0 1.666-.36 2.268-1.002l3.275-3.493",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgAttachment;